import { css } from 'styled-components';
import { rem } from 'polished';

import book from '../../../../assets/fonts/Montserrat-Regular.ttf';
import bookItalic from '../../../../assets/fonts/Montserrat-Italic.ttf';
import medium from '../../../../assets/fonts/Montserrat-SemiBold.ttf';
import mediumItalic from '../../../../assets/fonts/Montserrat-SemiBoldItalic.ttf';
import bold from '../../../../assets/fonts/Montserrat-Bold.ttf';
import boldItalic from '../../../../assets/fonts/Montserrat-BoldItalic.ttf';

const fonts = {
  book: '"Montserrat Regular", Helvetica, Arial, sans-serif',
  bookItalic: '"Montserrat Italic", Helvetica, Arial, sans-serif',
  medium: '"Montserrat Medium", Helvetica, Arial, sans-serif',
  mediumItalic: '"Montserrat Medium Italic", Helvetica, Arial, sans-serif',
  bold: '"Montserrat Bold", Helvetica, Arial, sans-serif',
  boldItalic: '"Montserrat Bold Italic", Helvetica, Arial, sans-serif',
  semiBold: 'OpenSans Semi Bold'
};

const fontSize = {
  xsmall: rem('12px'),
  small: rem('14px'),
  medium: rem('15px'),
  large: rem('18px'),
  xlarge: rem('20px')
};

// Carga de las fuentes
const fontsFace = css` 
  @font-face { 
      font-family: 'Montserrat Regular'; 
      src:  url('${book}');
      font-weight: 400;
  }
  @font-face { 
      font-family: 'Montserrat Italic'; 
      src:  url('${bookItalic}');
      font-weight: 400;
  }
  @font-face { 
      font-family: 'Montserrat Medium'; 
      src:  url('${medium}');
      font-weight: 500;
  }
  @font-face { 
      font-family: 'Montserrat Medium Italic'; 
      src:  url('${mediumItalic}');
      font-weight: 500;
  }
  @font-face { 
      font-family: 'Montserrat Bold'; 
      src:  url('${bold}');
      font-weight: 700;
  }
  @font-face { 
      font-family: 'Montserrat Bold Italic'; 
      src:  url('${boldItalic}');
      font-weight: 700;
  }
`;

export { fonts, fontsFace, fontSize };
